module.exports = __webpack_public_path__ + "media/application/images/svgs/star-47a6ec3c89ef018039b5513a6aab82e5.svg";